import  { useState } from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import { Container, Col, Row, Modal, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "../pages/styles/Cards.css";

const courses = [
  {
    id: 1,
    title: "GAT Certificate in Training Design Course",
    abbreviation: "TDC",
    content: (
      <div>
        <p>
          <strong>Course Overview:</strong> The goal of this course is to train
          managers, HR officers, and department heads how to choose suitable
          training techniques, develop training content, and decide how to
          evaluate this training.
        </p>
      </div>
    ),
  },
  {
    id: 2,
    title: "GAT Certificate in Quality Control management",
    abbreviation: "QC",
    content: (
      <div>
        <p>
          <strong>Course Overview:</strong> In order to maintain high standards
          in production, services, and organizational operations, the Quality
          Control management Course seeks to give participants a thorough
          understanding of quality management, quality control (QC) procedures,
          and efficient management practices.
        </p>
      </div>
    ),
  },
  {
    id: 3,
    title: "GAT Certificate in Capability Based Planning Course",
    abbreviation: "CBP",
    content: (
      <div>
        <p>
          <strong>Course Overview:</strong> Participants in a Capability-Based
          Planning (CBP) course will gain the knowledge and abilities needed to
          plan and build the capabilities required for organizational success,
          especially in complex situations. This strategy emphasizes evaluating
          and managing these skills over time and matching strategic objectives
          with the necessary capabilities.
        </p>
      </div>
    ),
  },
  {
    id: 4,
    title:
      "GAT Certificate in Professional Certified Train Of the Trainer (GAT PC-TOT)",
    abbreviation: "PC-TOT",
    content: (
      <div>
        <p>
          <strong>Course Overview:</strong> Anyone who needs to become
          proficient in training methods and procedures is intended to take this
          course. Designing and delivering successful training programs requires
          the knowledge, skills, and practical assistance offered by the
          Certificate of Global Achievement Test (GAT PC-TOT) in Professional
          Certified Trainer.
        </p>
      </div>
    ),
  },
];

function GATCertificates() {
  const { colorMode } = useColorMode();
  const [showModal, setShowModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleCardClick = (course) => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  return (
    <section
      className="course-grid-section"
      style={{ display: "flex", minHeight: "100vh", alignItems: "center" }}
      id="Courses-section"
    >
      <Helmet>
        <meta
          name="description"
          content="Explore a diverse range of Programs and Certifications offered by Talent Track to enhance your skills and advance your career. Join us today and unlock your potential!"
        />
      </Helmet>
      <Container className="text-center">
        <h1 className="mt-2">GAT Certiﬁcates</h1>
        <Box
          className="ag-courses_box"
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
        >
          {courses.map((course) => (
            <Col
              key={course.id}
              lg={3}
              md={6}
              sm={12}
              className="ag-courses_item"
              data-aos="fade-up"
              style={{ cursor: "pointer", marginBottom: "20px" }}
              onClick={() => handleCardClick(course)}
            >
              <div className="ag-courses-item_link">
                <div
                  className="ag-courses-item_bg"
                  style={{ backgroundColor: course.bgColor }}
                ></div>
                <div className="ag-courses-item_title">{course.title}</div>
                <div className="ag-courses-item_date-box">
                  <p>
                    <span className="ag-courses-item_date">
                      {course.abbreviation}
                    </span>
                  </p>
                </div>
                <div className="moon"></div>
              </div>
            </Col>
          ))}
        </Box>
      </Container>

      {/* Modal for course details */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <Modal.Header 
          closeButton
          style={{
            background: colorMode === 'dark' 
              ? 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
              : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            color: colorMode === 'dark' ? '#ffffff' : '#333333',
            border: 'none',
            borderRadius: '15px 15px 0 0',
            padding: '20px 25px'
          }}
        >
          <Modal.Title 
            style={{ 
              fontSize: '1.5rem', 
              fontWeight: 'bold',
              color: colorMode === 'dark' ? '#ffffff' : '#333333'
            }}
          >
            🎓 {selectedCourse?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            background: colorMode === 'dark' ? '#1a202c' : '#ffffff',
            color: colorMode === 'dark' ? '#ffffff' : '#333333',
            padding: '30px',
            fontSize: '1.1rem',
            lineHeight: '1.6'
          }}
        >
          <div 
            style={{
              background: colorMode === 'dark' 
                ? 'rgba(255, 255, 255, 0.05)'
                : 'rgba(0, 123, 255, 0.05)',
              padding: '20px',
              borderRadius: '10px',
              border: colorMode === 'dark' 
                ? '1px solid rgba(255, 255, 255, 0.1)'
                : '1px solid rgba(0, 123, 255, 0.1)'
            }}
          >
            {selectedCourse?.content}
          </div>
          
          <div 
            style={{
              marginTop: '20px',
              padding: '15px',
              background: colorMode === 'dark'
                ? 'rgba(72, 187, 120, 0.1)'
                : 'rgba(40, 167, 69, 0.1)',
              borderRadius: '8px',
              border: colorMode === 'dark'
                ? '1px solid rgba(72, 187, 120, 0.3)'
                : '1px solid rgba(40, 167, 69, 0.3)'
            }}
          >
            <h5 style={{ 
              color: colorMode === 'dark' ? '#48bb78' : '#28a745',
              marginBottom: '10px',
              fontSize: '1.2rem'
            }}>
              📋 Certificate Code
            </h5>
            <p style={{ 
              fontSize: '1.3rem', 
              fontWeight: 'bold',
              margin: 0,
              color: colorMode === 'dark' ? '#ffffff' : '#333333'
            }}>
              {selectedCourse?.abbreviation}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            background: colorMode === 'dark' 
              ? 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
              : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: 'none',
            borderRadius: '0 0 15px 15px',
            padding: '20px 25px'
          }}
        >
          <Button 
            variant={colorMode === 'dark' ? 'outline-light' : 'primary'}
            onClick={() => setShowModal(false)}
            style={{
              padding: '10px 25px',
              fontSize: '1rem',
              fontWeight: '600',
              borderRadius: '8px',
              transition: 'all 0.3s ease'
            }}
          >
            ✕ Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default GATCertificates;
